@if (showConsole()) {
  <div
    class="drag-boundary pointer-events-none absolute left-0 top-0 h-full w-full"
  >
    <div
      cdkDrag
      class="pointer-events-auto absolute right-6 top-16 z-50 h-[180px] w-[240px] select-none rounded-lg"
      cdkDragBoundary=".drag-boundary"
    >
      <div
        class="flex items-center justify-between rounded-t-lg bg-bo-black/50 px-2 backdrop-blur-md"
      >
        <div class="bo-title !text-bo-white">Console</div>
        <svg-icon
          src="fa-icons/xmark.svg"
          class="fill-bo-white"
          [svgStyle]="{ 'height.px': 16 }"
          (click)="appService.showConsole.set(false)"
        />
      </div>
      <div
        class="no-scrollbar h-full overflow-y-auto rounded-b-lg bg-bo-black/70 px-2 pb-2 backdrop-blur-md"
      >
        @for (log of logs(); track log) {
          <div
            class="bo-console border-b-[1px] border-bo-white/20 py-2"
            [ngClass]="{
              '!text-red-400': log.type === 'error',
              '!text-yellow-400': log.type === 'warn',
            }"
          >
            @for (message of log.messages; track message) {
              <div>
                {{ message }}
                @if (log.args) {
                  <span>: {{ log.args }}</span>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
